import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base-service';
import { AuthService } from '@auth0/auth0-angular';
import { UsersService } from './users.service';

export enum FormType
{
    FormSubmission,
    MarketingMaterial
}

export enum SubmissionType
{
    Other,
    NewSubmission,
    Resubmission,
    LawChange,
    MbrChange,
    SameOrSimilar,
}
export interface CreatePricingRuleRequest {
  formType: number;
  submissionTypeId: number;
  stateCount: number;
  price: number;
}

export interface CreateBillingRuleGroupRequest {
  name: string;
  priceRules: CreatePricingRuleRequest[];
}

@Injectable({
  providedIn: 'root',
})
export class BillingRuleService extends BaseService {

  constructor(
    http: HttpClient,
    private userService: UsersService,
    private auth: AuthService
  ) {
    super(http, `billingrulegroup`);
  }
}
